import React, { useRef } from 'react';
import {
    Chart,
    ChartData,
    ChartOptions,
} from 'chart.js';
import { FiltroSopInventory } from '../../core/repositories/sopInventoryRepositorio';
import { formatarDecimal } from '../../core/utils/funcoes';
import { Line } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';
import { useToast } from '../../core/contexts/toast';
import { RepositorioSopInventory } from '../../core/repositories/sopInventoryRepositorio';
import SopLoadingAnimation from '../../components/sopLoadingAnimation';


const SopInventoryForecastChart: React.FC<{ filtro: FiltroSopInventory }> = (props) => {

    const { mostrarToast } = useToast();
    const { t } = useTranslation();

    const chartRef = useRef<Chart<'line'>>(null);
    const [data, setData] = React.useState<ChartData<'line'>>({} as ChartData<'line'>);
    const [carregando, setCarregando] = React.useState(true);

    React.useEffect(() => {
        setCarregando(true);
        new RepositorioSopInventory().getKpis(props.filtro).then((res) => {
            const labels: string[] = [];
            const turn: (number | null)[] = [];
            const doh: (number | null)[] = [];

            res.forEach((item: any) => {
                labels.push(item.mes || "");
                turn.push(item.hasOwnProperty('turn') ? item.turn : null);
                doh.push(item.hasOwnProperty('doh') ? item.doh : null);
            });

            setData({
                labels: labels,
                datasets: [
                    {
                        label: 'Inventory Turnover',
                        data: turn,
                        borderColor: '#90CAF9',
                        backgroundColor: '#90CAF9',
                    },
                    {
                        label: 'Days of Inventory on Hand',
                        data: doh,
                        borderColor: '#0089F8',
                        backgroundColor: '#0089F8',
                        yAxisID: 'y2',
                    },
                ],
            });
            setCarregando(false);
        }).catch((error) => {
            mostrarToast({
                titulo: t("pages.Erro!"),
                mensagem: t("pages.Aconteceu algo inesperado, por favor tente novamente mais tarde!"),
                tipo: "error",
            });
        })




    }, [props.filtro]);

    // const data: ChartData<"line"> = {
    //     labels: ['Dec/2024', 'Jan/2025', 'Feb/2025', 'Mar/2025', 'Apr/2025', 'May/2025', 'Jun/2025'],
    //     datasets: [

    //         {
    //             label: 'Forecast Accuracy',
    //             data: [75, 85, 94, 52, 62, 45, 48],
    //             borderColor: '#90CAF9',
    //             backgroundColor: '#90CAF9',
    //         },
    //         {
    //             label: 'YoY',
    //             data: [85, 74, 105, 96, 85, 74, 85],
    //             borderColor: '#0089F8',
    //             backgroundColor: '#0089F8',
    //         },

    //     ],
    // }

    const options: ChartOptions<"line"> = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
            },
            tooltip: {
                mode: 'index',
                intersect: false,
            },
            title: {
                display: false,
            },
        },
        interaction: {
            mode: 'nearest',
            axis: 'x',
            intersect: false,
        },
        scales: {
            x: {
            },
            y: {
                title: {
                    display: true,
                    text: 'Inventory Turnover',
                },
                ticks: {
                    callback:
                        (value: any) => formatarDecimal(value)
                    // props.filtro?.value !== "Quantity"
                    //     ? (value: any) => formatarDecimal(value, true)
                    //     : (value: any) => formatarDecimal(value),
                },
                beginAtZero: false,
            },
            y2: {
                title: {
                    display: true,
                    text: 'Days',
                  
                },
                type: 'linear',
                position: 'right',
                beginAtZero: false,
            },
        },
    }


    return (


        <div className="card p-3 shadow-sm border-0" style={{ height: '250px' }}>
            <strong className=" title-card">KPI</strong>
            {carregando ?
                <SopLoadingAnimation type="LINE" />
                :
                <div>
                    <Line ref={chartRef} options={options} data={data} />
                </div>
            }
        </div>
    );
};

export default SopInventoryForecastChart;
